var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fact"
  }, [(_vm.showingForm && _vm.editable) ? _c('form', [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "cm-label",
    attrs: {
      "for": "f_header"
    }
  }, [_vm._v(_vm._s(_vm.I18n.t('question_title')))]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fact.header_value),
      expression: "fact.header_value"
    }],
    staticClass: "cm-field val-required",
    attrs: {
      "type": "text",
      "id": "f_header",
      "required": "true",
      "placeholder": _vm.I18n.t('question_title')
    },
    domProps: {
      "value": (_vm.fact.header_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fact.header_value = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "cm-label",
    attrs: {
      "for": "f_text"
    }
  }, [_vm._v(_vm._s(_vm.I18n.t('your_answer')))]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fact.text_value),
      expression: "fact.text_value"
    }],
    staticClass: "cm-field val-required",
    attrs: {
      "type": "text",
      "id": "f_text",
      "required": "true",
      "placeholder": _vm.I18n.t('your_answer')
    },
    domProps: {
      "value": (_vm.fact.text_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fact.text_value = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-action-row"
  }, [_c('input', {
    staticClass: "cm-button save-changes",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.I18n.t('save')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleSave($event)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "cancel-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v(_vm._s(_vm.I18n.t("cancel")))]), _vm._v(" "), (_vm.isExistingFact) ? _c('a', {
    staticClass: "delete-link",
    attrs: {
      "rel": "nofollow",
      "data-method": "delete",
      "href": ("/companies/" + (_vm.company.id) + "/facts/" + (_vm.fact.id))
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.I18n.t('delete_fact')))])]) : _vm._e()])]) : [_c('div', {
    staticClass: "fact__header"
  }, [_vm._v(_vm._s(_vm.fact.header_value))]), _vm._v(" "), _c('div', {
    staticClass: "fact__text"
  }, [_c('span', [_vm._v(_vm._s(_vm.fact.text_value))]), _vm._v(" "), (_vm.editable) ? _c('button', {
    staticClass: "edit-button ss-icon",
    on: {
      "click": _vm.toggleForm
    }
  }, [_vm._v("compose")]) : _vm._e()])]], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2681498f","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/company/fact.vue
// module id = null
// module chunks = 